import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/app/src/components/SessionProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DialogPortalContext"] */ "/app/src/components/ui/dialog/DialogPortalContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorDialogSlotContext","ErrorDialogSlot"] */ "/app/src/components/ui/dialog/ErrorDialogSlot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppInsightsProvider"] */ "/app/src/components/utils/AppInsightsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClockTimestampProvider"] */ "/app/src/components/utils/clock/ClockTimestampProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DarkModeProvider"] */ "/app/src/components/utils/DarkModeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeatureToggleProvider"] */ "/app/src/components/utils/FeatureToggleContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InactivityTimoutProvider"] */ "/app/src/components/utils/InactivityTimeoutProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoggerProvider"] */ "/app/src/components/utils/LoggerProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProcessSearchParams"] */ "/app/src/components/utils/ProcessSearchParams.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServerEnvironmentProvider"] */ "/app/src/components/utils/ServerEnvironmentContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserAgentDeviceTypeProvider"] */ "/app/src/components/utils/UserAgentDeviceTypeContext.tsx");
